import './Home.css';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <>
      <div className="wave-wrapper">
        <img src="wave.jpg" className="wave-image" alt="wave background" />
        <div className="light-wave">
          <h1>Luxury Web Experiences — Crafted from Scratch.</h1>
          <p>No templates. No shortcuts. Just meticulously engineered websites tailored to your brand.</p>
          <Link to="/consultation">
            <button>Schedule a Consultation</button>
          </Link>
        </div>
      </div>

      <section className="section mission-section">
        <div className="content">
          <h2>Our Mission</h2>
          <p>
            At Haaskel, we believe your website should be a masterpiece — not just a placeholder. Every pixel is intentional, every line of code engineered for speed, beauty, and results.
          </p>
        </div>
      </section>

      <section className="section services-section">
        <div className="content">
          <h2>What We Offer</h2>
          <ul>
            <li> Custom design systems with a user-first approach</li>
            <li> Lightning-fast performance with hand-coded frontends</li>
            <li> SEO-optimized architecture to boost discoverability</li>
            <li> Seamless integrations: APIs, CMSs, eCommerce & more</li>
          </ul>
        </div>
      </section>

      <section className="section difference-section">
        <div className="content">
          <h2>What Makes Haaskel Different?</h2>
          <p>
            We don’t use templates or bloated frameworks. Our team combines art direction with elite-level engineering to deliver stunning, performant, and future-proof sites.
          </p>
        </div>
      </section>

      <section className="section cta-section">
        <div className="cta-box">
          <h2>Let’s Build Something Legendary</h2>
          <p>Have an idea? Let’s craft a digital experience that exceeds expectations.</p>
          <Link to="/consultation">
            <button>Request a Consultation</button>
          </Link>
        </div>
      </section>
    </>
  );
};

export default Home;
